module.exports = __webpack_public_path__ + "img/5.97272c7e.jpg";